import PropTypes from 'prop-types';
import compose from "ramda/es/compose";
import ifElse from "ramda/es/ifElse";
import when from "ramda/es/when";
import cx from "ramda-extension/es/cx";
import React, { cloneElement, Component, createElement, isValidElement } from 'react';
import { withDefaultComponentProps } from '../../../decorators/withDefaultComponentProps';
import DropdownContent from '../DropdownContent';
import { createDropdownCloseEvent } from '../utils';
const COMPONENT_NAME = 'Dropdown';
class Dropdown extends Component {
    state = {
        contentVisible: false
    };
    handleDropdownVisibility = (e)=>{
        e?.preventDefault();
        this.setState({
            contentVisible: !this.state.contentVisible
        });
    };
    dispatchCloseOtherDropdownEvent = ()=>{
        document.dispatchEvent(createDropdownCloseEvent());
    };
    createToggleElement = (toggleElement)=>/*#__PURE__*/ React.createElement("div", {
            className: cx('Dropdown-toggle', 'ignore-react-onclickoutside'),
            onClick: this.props.openOnRightClick ? null : this.handleDropdownVisibility
        }, toggleElement);
    cloneToggleElement = (toggleElement)=>{
        const onClickFns = [
            this.dispatchCloseOtherDropdownEvent
        ];
        if (toggleElement.props.onClick) {
            onClickFns.push(toggleElement.props.onClick);
        }
        if (!this.props.openOnRightClick) {
            onClickFns.unshift(this.handleDropdownVisibility);
        }
        return /*#__PURE__*/ cloneElement(toggleElement, {
            className: cx('Dropdown-toggle', 'ignore-react-onclickoutside', toggleElement.props.className),
            onClick: compose(...onClickFns)
        });
    };
    renderToggleElement = ifElse(isValidElement, this.cloneToggleElement, this.createToggleElement);
    handleCloseOnContentClick = ()=>{
        if (this.props.closeOnClick) {
            setTimeout(()=>this.handleDropdownVisibility());
        }
    };
    render() {
        const { className, closeWhenOtherOpened, children, snapBottom, snapRight, toggleElement, closeOnClick, containerElement, openOnHover, openOnRightClick, ...other } = this.props;
        const contentChildren = this.state.contentVisible ? /*#__PURE__*/ React.createElement(DropdownContent, {
            visible: true,
            snapBottom: snapBottom,
            snapRight: snapRight,
            onClickOutside: when(this.handleDropdownVisibility, this.state.contentVisible),
            onClickCapture: this.handleCloseOnContentClick,
            onOpenOtherDropdown: this.handleDropdownVisibility,
            closeWhenOtherOpened: closeWhenOtherOpened
        }, children) : null;
        const outputElementProps = {
            className: cx('Dropdown', className),
            onMouseEnter: openOnHover ? this.handleDropdownVisibility : null,
            onMouseLeave: openOnHover ? this.handleDropdownVisibility : null,
            onContextMenu: openOnRightClick ? this.handleDropdownVisibility : null,
            ...other
        };
        const childrenFragment = /*#__PURE__*/ React.createElement(React.Fragment, null, this.renderToggleElement(toggleElement), contentChildren);
        return /*#__PURE__*/ isValidElement(containerElement) ? /*#__PURE__*/ cloneElement(containerElement, outputElementProps, childrenFragment) : /*#__PURE__*/ createElement(containerElement, outputElementProps, childrenFragment);
    }
}
Dropdown.propTypes = {
    /**
	 * Children will be rendered within the `Dropdown`.
	 */ children: PropTypes.node,
    /**
	 * Custom `className` for the root.
	 */ className: PropTypes.string,
    /**
	 * Dropdown will close itself when clicked somewhere in content
	 */ closeOnClick: PropTypes.bool,
    /**
	 * Dropdown will be closed when other Dropdown is opened. Default true.
	 */ closeWhenOtherOpened: PropTypes.bool,
    /**
	 * Element or Component used as the root tag.
	 */ containerElement: PropTypes.node,
    /**
	 * If true, dropdown will open on mouse enter and close on mouse leave
	 */ openOnHover: PropTypes.bool,
    /**
	 * If true, dropdown will open on right click
	 */ openOnRightClick: PropTypes.bool,
    /**
	 * If true, DropdownContentUndecorated has snapBottom class
	 */ snapBottom: PropTypes.bool,
    /**
	 * If true, DropdownContentUndecorated has snapRight class
	 */ snapRight: PropTypes.bool,
    /**
	 * ToggleElement
	 */ toggleElement: PropTypes.node
};
export { Dropdown };
export default withDefaultComponentProps(COMPONENT_NAME, {
    containerElement: 'div',
    closeOnClick: true,
    closeWhenOtherOpened: true
}, Dropdown);
